import { DatePipe, isPlatformBrowser } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  inject,
  mergeApplicationConfig,
  PLATFORM_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
  REQUEST
} from '@angular/core';
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withViewTransitions } from '@angular/router';
import { STORAGE_TOKEN } from '../oex-ui-kit/services/storage.service';
import { onViewTransitionCreated } from '../oex-ui-kit/services/view-transition.service';
import { routes } from './app.routes';
import { httpInterceptor } from "./services/http-interceptor";
import { StartupService } from "./services/startup.service";
import { StorageService } from './services/storage.service';

export const initializeApplication = async () => {
  // Temporary fix to prevent Angular CLI execute app initializer during build process
  const req = inject(REQUEST, { optional: true });
  const platformId = inject(PLATFORM_ID);
  if (!req && !isPlatformBrowser(platformId)) {
    return;
  }

  await inject(StartupService).initialize();
};

/*const scrollConfig: InMemoryScrollingOptions = {
  anchorScrolling: 'disabled',
  scrollPositionRestoration: 'disabled'
};*/

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideHttpClient(withInterceptors([httpInterceptor]), withFetch()),
    provideClientHydration(),
    provideZonelessChangeDetection(),
    //provideAnimations(),
    provideRouter(
      routes,
      // withInMemoryScrolling(scrollConfig)
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated
      })
      // withDebugTracing()
      // withPreloading(PreloadAllModules)
    ),
    provideAppInitializer(initializeApplication),
    { provide: STORAGE_TOKEN, useClass: StorageService }
  ]
};

const browserConfig: ApplicationConfig = {
  providers: [
    provideAnimations()
  ]
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
